import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.reduce-right";
import _toConsumableArray from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _typeof from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Request from './Request';
import ajax from '../senders/ajax';

var _defaultSender = ajax();

function makeRunner(stack) {
  return stack.reduceRight(function (next, fn) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fn.apply(this, [next.bind(this)]));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  });
}

export function setDefaultSender(sender) {
  _defaultSender = sender;
}
/**
 * 创建一个Coa请求执行器
 * @param  {Array} fns 中间件
 */

export function createCoa() {
  var fns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sender = arguments.length > 1 ? arguments[1] : undefined;

  if (!Array.isArray(fns)) {
    console.error('创建coa的fns参数不是数组类型', _typeof(fns), fns);
  } // mock中间件在生产环境下返回undefined而不是一个函数，需要特别过滤一下


  fns = fns.filter(function (fn) {
    return fn;
  });

  var _iterator = _createForOfIteratorHelper(fns),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var fn = _step.value;

      if (typeof fn !== 'function') {
        console.error('创建coa的fns参数中包含非函数类型的中间件', _typeof(fn), fn);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var stack = [].concat(_toConsumableArray(fns), [sender || _defaultSender || ajax()]);
  var runner = makeRunner(stack);

  var coa = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, data, options) {
      var context;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              context = {
                request: new Request(url, data, options),
                response: null,
                error: undefined
              };
              _context2.next = 3;
              return runner.apply(context);

            case 3:
              if (!context.error) {
                _context2.next = 7;
                break;
              }

              throw context.error;

            case 7:
              return _context2.abrupt("return", context.response);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function coa(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  coa.run = coa;
  return coa;
}